export default __webpack_public_path__ + "static/media/account-info.70f69350.svg";